import React from "react";
import { useState } from "react";
import ProfileModal from "./ProfileModal"; 
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Sidebar2 = ({ isOpen, toggleSidebar }) => {
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const navigate = useNavigate();
const handleLogout = () => {
  navigate("/admin/login");
  localStorage.removeItem("admin");
};
  return (
    <div>
      {/* Sidebar */}
      <div
       style={{
        position: "fixed",
        top: "50px", // Positioned below the header
        right: isOpen ? "0px" : "-300px", // Slides in from the right
        width: "200px",
        height: "auto",
        backgroundColor: "#343A40",
        zIndex: 12, // Corrected: Use camelCase
        color: "#fff",
        padding: "15px",
        transition: "right 0.3s ease-in-out",
        borderRadius: "10px",
        boxShadow: "0 0 10px rgba(0,0,0,0.3)",
      }}
      
      >
       
        <ul style={{ listStyle: "none", padding: 0 }}>
        <li
            style={{ padding: "10px 0", cursor: "pointer", color: "white" }}
            onClick={() => setIsProfileOpen(true)}
          >
            Profile
          </li>
          {/* <li style={{ padding: "10px 0", cursor: "pointer" }}>
        <Link to="/admin/betHistory" style={{ textDecoration: "none", color: "inherit" }}>
            My Bets
        </Link>
        </li> */}
        <li style={{ padding: "10px 0", cursor: "pointer" }}>
        <Link to="/admin/profitloss" style={{ textDecoration: "none", color: "inherit" }}>
            Profit & Loss
        </Link>
        </li>
        <li style={{ padding: "10px 0", cursor: "pointer" }}>
        <Link to="/admin/sportHistory" style={{ textDecoration: "none", color: "inherit" }}>
            Sport History
        </Link>
        </li>
        <li style={{ padding: "10px 0", cursor: "pointer" }}>
        <Link to="/admin/userChip" style={{ textDecoration: "none", color: "inherit" }}>
            User Chip
        </Link>
        </li>
         
        </ul>
        <button
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: "red",
            color: "white",
            border: "none",
            cursor: "pointer",
           
          }}
          onClick={handleLogout}
        >
          Logout
        </button>
              {/* Profile Modal */}
      <ProfileModal
        isOpen={isProfileOpen}
        onClose={() => setIsProfileOpen(false)}
      />
      </div>

    </div>
  );
};

export default Sidebar2;